import { render, staticRenderFns } from "./carouselComponent.vue?vue&type=template&id=3938fef0&scoped=true"
import script from "./carouselComponent.vue?vue&type=script&lang=js"
export * from "./carouselComponent.vue?vue&type=script&lang=js"
import style0 from "./carouselComponent.vue?vue&type=style&index=0&id=3938fef0&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/zujian/carouselComponent.less?vue&type=style&index=1&id=3938fef0&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938fef0",
  null
  
)

export default component.exports